/**
 * Report groups: what the editor's preview renders for a group MEMBER.
 *
 * A member owns no filters (its group does), so its own
 * ``dashboard_config`` has none. The preview draws the group's filters
 * merged at the member's columns (``draft.group.filters``, merged by the
 * server with the engine's ``merge_group_filters``), so the canvas shows
 * what the portal serves. ONLY for rendering: the editor state, which is
 * what a save writes, never carries them (a member that saved the
 * group's filters as its own would be refused at publish).
 */
import type { DashboardConfigV2, ReportDraft } from "@/types";

export function withGroupFilters(
  dashboard: DashboardConfigV2,
  draft: ReportDraft | null | undefined,
): DashboardConfigV2 {
  const filters = draft?.group?.filters;
  if (!filters) return dashboard;
  return { ...dashboard, global_filters: filters };
}
